module.exports = __webpack_public_path__ + "static/media/VE.8b333ba5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/VE.svg
// module id = 388
// module chunks = 0